export default __webpack_public_path__ + "static/media/boy9.b9ffc11b.jpg";